import { strategyToOptions } from '@/common/utils/strategyToOptions'

export const allowedDriverEquipmentBranchHierarchyForConsumption = {
  require_same_branch: 'Da mesma filial',
  require_same_branch_or_direct_children: 'Da mesma filial e das filiais filhas direta',
  allow_from_any_branch: 'De qualquer filial da empresa',
  require_same_branch_or_all_descendants: 'Da mesma filial e das filiais descendentes',
}

export const allowedDriverEquipmentBranchHierarchyForConsumptionOptions = strategyToOptions(
  allowedDriverEquipmentBranchHierarchyForConsumption,
)
